import { jsx } from 'react/jsx-runtime';

/**
 * Separatore da utilizzare in un Application.Header
 */
function Separator() {
    return jsx("div", { className: "application__header-sparator" });
}
Separator.displayName = 'Application.Separator';

export { Separator as default };
